import { render, staticRenderFns } from "./MessagingAnalytics.vue?vue&type=template&id=5574a6f5&scoped=true"
import script from "./MessagingAnalytics.vue?vue&type=script&lang=js"
export * from "./MessagingAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5574a6f5",
  null
  
)

export default component.exports